
import React from 'react';

interface IconProps {
  size?: number;
}

const TypescriptIcon: React.FC<IconProps> = ({ size = 24 }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size}>
      <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zM8.22 17.658h-1.54V9.3h1.54v8.358zm5.082 0v-1.54l1.54-.22v-3.3l-1.54-.22V9.3h4.62v1.54h-3.08v2.64l3.08.44v1.76h-4.62z" fill="#3178C6"/>
    </svg>
  );
};

export default TypescriptIcon;
